
import * as BusinessDAL from '../dal/business-dal'
import * as MessagingBL from "../bl/messaging-bl";
import { get } from "svelte/store";

import {
    business
} from "../stores.js";

export function setNotifications(onOff, code, token) {

    let currentNotifications = get(business).notifications;

    if (!token) {
        MessagingBL.initMessaging().then((token) => {
            if (!token) {
                console.log("notification permission denied");
                return;
            }
            console.log('setNotifications. setting business fcm token after initMessaging:')
            console.log(token)
            BusinessDAL.toggleNotification(code, onOff, token, currentNotifications);

        }).catch((e) => {
            console.error(e);
        });
    } else {
        console.log('setNotifications. setting business fcm token:')
        console.log(token)
        BusinessDAL.toggleNotification(code, onOff, token, currentNotifications);


    }
}
